module.exports = __webpack_public_path__ + "static/media/llama-user-icon.6a2cff9b.png";